module.exports = __webpack_public_path__ + "intro-new.06382bdeb179fae2d5e1.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/assets/img/intro-new.jpg
// module id = ../../../../../src/assets/img/intro-new.jpg
// module chunks = styles